import React from "react";

function Post() {
  const posts = [
    {
      title: "Why Testing Matters More Than Ever in the Age of AI",
      date: "09/12/2025",
      content: (
        <>
          <p>
            These days, AI is running exceptionally clean and efficient code. As someone who has been using it for quite some time, I believe it would be more beneficial for software engineers to focus more on testing.
          </p>
          <p>
            AI can work perfectly—there's no doubt about it—and I challenge anyone who says otherwise. I'm emphasizing this because testing is really important. AI can function well, but it can sometimes make mistakes, just like humans do.
          </p>
          <p>
            However, I think spending more time on testing will significantly alleviate or even eradicate some of the poor UI experiences we might encounter or the unexpected behavior of software programs that might require fixes. This would free up resources that could be used on other features or projects.
          </p>
        </>
      ),
    },
    {
      title: "The Era of Artificial Intelligence: Change Is Here",
      date: "05/21/2025",
      content: (
        <>
          <p>
            The era of artificial intelligence (AI) is upon us, and it's a significant development. However, many people still don't grasp its implications. AI is poised to bring substantial change, as advancements are happening rapidly.
          </p>
          <p>
            While this progress is exciting, it's also a bit intimidating, especially considering we're still in the early stages. As AI evolves, it will transform various aspects of our lives, and keeping pace with these innovations will be crucial.
          </p>
        </>
      ),
    },
    {
      title: "The New Age of Digital Industrialization – Opportunity or Disruption?",
      date: "05/12/2025",
      content: (
        <>
          <p>
            We’re entering a new era of industrialization—but this time, it’s digital. Artificial intelligence is transforming the way we work, and while some view it as a threat, I see both challenges and incredible opportunities.
          </p>
          <p>
            AI has already made its way into our daily workflows—from task automation to resource optimization. When implemented thoughtfully, these tools can enable organizations to scale vertically, increasing output while using fewer resources.
          </p>
          <p>
            But with this transformation comes uncertainty. Will automation displace jobs faster than we can create new ones? Possibly. Yet, if we use these technologies wisely, they could actually free up human capital—allowing us to invest in new projects, spark innovation, and tackle problems we haven’t even imagined yet.
          </p>
          <p>
            This could also accelerate our progress in areas like space exploration, where we're just beginning to scratch the surface. Imagine building a spacecraft that can carry more cargo, but struggling with the high fuel cost. Should we wait for a new fuel system—or start building now and adapt as we go?
          </p>
          <p>
            The bigger question I keep coming back to is this:<br />
            <strong>In a world of accelerating possibilities, will we be able to choose the right projects to invest in?</strong>
          </p>
          <p>
            Because technology is just a tool. The real transformation depends on how we use it—and the decisions we make today will shape our collective future.
          </p>
          <div className="mt-4 p-3 bg-light border rounded">
            <strong>Join the discussion:</strong> Share your thoughts or comment on this topic on my{" "}
            <a
              href="https://www.linkedin.com/posts/adigbe-houndonougbo-sadric-4477361b5_the-new-age-of-digital-industrialization-activity-7327754382844801025-lNKH?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAADIewfcBl-1SIBkDteoc8ORpEhAfVSpDlcE"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              LinkedIn post
            </a>
            .
          </div>
        </>
      ),
    },
    {
      title: "Want to Get Better at Prompt Engineering? 💡",
      date: "05/05/2025",
      content: (
        <>
          <p>
            Start by diving deeper into your own field — whether it's coding, design, or marketing. The more you know, the better prompts you’ll craft.
          </p>
          <p>
            Prompt engineering is really just clear instruction. For example:
          </p>
          <p>
            If you're building a web or mobile app and want a better UI layout, using terms like <strong>margin</strong> and <strong>padding</strong> in your prompt tells the AI exactly what you're aiming for.
          </p>
          <p>
            The more precise your language, the smarter the output.
          </p>
          <p>
            Know your craft — and you'll be prompting like a pro in no time. 💡
          </p>
        </>
      ),
    },
    {
      title: "Big News: iHtrack is Officially Live on the App Store! 🚀",
      date: "04/28/2025",
      content: (
        <>
          <p>
            We’re thrilled to announce that iHtrack — your ultimate home inventory and organization companion — is now officially available for download on the App Store!
          </p>
          <ul>
            <li>Effortlessly manage your home items</li>
            <li>Track inventory levels and refill needs</li>
            <li>Organize by categories like groceries, electronics, books, and more</li>
            <li>Personalize your profile with your name and photo</li>
          </ul>
          <p>
            Stay on top of your belongings. Stay organized. Stay stress-free.
          </p>
          <p>
            <strong>Download iHtrack today and take control of your home inventory like never before!</strong>
          </p>
          <p>
            👉 <a href="https://apps.apple.com/us/app/ihtrack/id6745040614" target="_blank" rel="noopener noreferrer">Get iHtrack on the App Store</a>
          </p>
          <p>Thank you for your support — this is just the beginning. More features and updates are already on the way!</p>
          <p className="text-muted">#iHtrack #HomeInventory #NowAvailable #OrganizeBetter</p>
        </>
      ),
    },
    {
      title: "A Funny Debugging Story",
      date: "04/27/2025",
      content: (
        <>
          <p>
            Vibe coding or vibe debugging? 😂 Honestly, I’m picking the latter. A bug 🐞 is the last thing you want crawling around in your code. 
            Funny story: I was adding a privacy policy page with React on my website for my iOS mobile app, and I accidentally named the component 
            <code> pPolocy</code> — starting with a lowercase letter. Of course, it refused to render until I realized it needed to start with a capital. 
            Super frustrating because even VS Code Copilot was no help — it kept saying everything looked fine and tossing in comments that just confused me more. 
            <strong> Moral of the story:</strong> you still gotta know your stuff if you wanna guide AI properly.
          </p>
          <p className="mt-4 text-muted">
            Stay tuned for my iOS app when it is validated by the app team. It is a simple home inventory tracker named 
            <span style={{ color: "#007BFF", fontWeight: "bold" }}> iHTrack</span>.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="post-section">
      {posts.map((post, index) => (
        <div key={index} className="mb-5 p-4 shadow rounded bg-light">
          <h2 className="text-xl font-bold mb-2">{post.title}</h2>
          <p className="text-sm text-gray-500">Posted on: {post.date}</p>
          {post.content}
        </div>
      ))}
    </div>
  );
}

export default Post;
